module.exports = __webpack_public_path__ + "static/art-96ca6ebffb940cb4db11f4faf3e22236.png";